import { render } from "./EcosistemasModal2.vue?vue&type=template&id=0f565fe6&scoped=true"
import script from "./EcosistemasModal2.vue?vue&type=script&lang=js"
export * from "./EcosistemasModal2.vue?vue&type=script&lang=js"

import "./EcosistemasModal2.vue?vue&type=style&index=0&id=0f565fe6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f565fe6"]])

export default __exports__